import TierRewardsContent from "./TierRewardsContent";

export default TierRewardsContent;
